(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sticky-cta-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  var bar = document.getElementById('sticky-cta-bar');
  var trigger = parseInt(bar.getAttribute('data-trigger'), 10);

  window.addEventListener('scroll', function() {
    if (window.scrollY > trigger) {
      bar.style.display = 'flex';
    } else {
      bar.style.display = 'none';
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
